import { Typography } from "PFComponents/typography";

type CustomCellProps = {
  value: string | undefined;
};

export const CustomCell = ({ value }: CustomCellProps) => (
  <Typography withMargin variant="bodyRegular" tag="span">
    {value ?? "-"}
  </Typography>
);
